<template>
  <div style="width: 100%">

    <el-collapse v-model="activeName" accordion>

      <el-collapse-item v-for="(item,key) in sensorType" :key="key" :name="key" class="box">
        <template slot="title">
          <el-checkbox v-model="item.check">{{item.name}}</el-checkbox>
        </template>
        <div class="Sensor_form">
          <sensor-type-form :sensor="item">


          </sensor-type-form>
        </div>
      </el-collapse-item>

    </el-collapse>
  </div>
</template>

<script>

  import SensorTypeForm from "../../temporarycomponents/sensorTypeForm";

  export default {
    components: {SensorTypeForm},
    name: "SensorTypes",
    data() {
      return {
        activeName: '1',
        clickedname: 0
      }
    },
    props: {
      sensorType: {
        type: Array,
        required: true
      }
    }, methods: {
      setclickedname(key) {
        this.clickedname = key;
      }
    }
  }
</script>

<style lang="scss" scoped>
  .Sensor_form {
    padding-left: 2%;
    padding-right: 2%;
    margin-left: 2%;
    margin-right: 2%;
    margin-top: 2%;
    border-left-style: solid;
    border-right-style: solid;
    border-color: #ebeef5;
    border-width: thin;
  }

  .new_SensT {
    height: 48px;
    line-height: 48px;
    color: #303133;
    cursor: pointer;
    border-bottom: 1px solid #ebeef5;
    font-size: 13px;
    font-weight: 500;
    -webkit-transition: border-bottom-color .3s;
    transition: border-bottom-color .3s;
    outline: 0;
    text-align: center;
    font-size: medium;
  }

  .box {
    position: relative;
  }

</style>



// WEBPACK FOOTER //
// src/views/settings/newGateWay/subComponents/sensorTypes.vue